module.exports = __webpack_public_path__ + "img/card-visa.21682580.jpg";